import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './_modules/shared/shared.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtInterceptorService } from './_interceptors/jwt-interceptor.service';
import { LocaleFallbackProvider } from './_services/locale-fallback.services';

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        SharedModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true },
        { provide: LOCALE_ID, useFactory: angularLocaleFactory },
        LocaleFallbackProvider,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
export function angularLocaleFactory(): string {
  const rawLocale =
    navigator.language || (navigator.languages && navigator.languages[0]) || 'en';

  return rawLocale.toLowerCase() === '1s' ? 'es-CL' : rawLocale;
}